export const name = "CURRENT_TIME";
export const summary = `Returns the current time as a \`TIME\` value.`;
export const reference = `
## CURRENT_TIME

Returns the current time as a \`TIME\` value.

\`\`\`
CURRENT_TIME([time_zone])
\`\`\`

### 

\`\`\`
CURRENT_TIME
\`\`\`


### Description

Returns the current time as a \`TIME\` object. Parentheses are optional when called with no arguments.

This function supports an optional \`time_zone\` parameter. See Time zone definitions for information on how to specify a time zone.

The current time value is set at the start of the query statement that contains this function. All invocations of \`CURRENT_TIME()\` within a query statement yield the same value.


### Return Data Type

\`TIME\`


### Example



\`\`\`
SELECT CURRENT_TIME() as now;

/*----------------------------*
 | now |
 +----------------------------+
 | 15:31:38.776361 |
 *----------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/time_functions
`;
